
export const loadingToggle = (isLoading) => {
  return (dispatch) => {
    dispatch({
      type: "LOADING_TOGGLE",
      isLoading,
    })
  }
}
